import { getProportionateVwPadding, stripUnit } from '@/utils/styling';

export const devices = {
  max: {
    mobile: 767,
    tablet: 1025,
    desktopSm: 1279,
  },
  min: {
    tablet: 768,
    desktopSm: 1026,
    desktop: 1280,
  },
} as const;

export const medias = {
  max: {
    mobile: `@media (max-width: ${devices.max.mobile}px)`,
    tablet: `@media (max-width: ${devices.max.tablet}px)`,
    desktopSm: `@media (max-width: ${devices.max.desktopSm}px)`,
  },
  min: {
    tablet: `@media (min-width: ${devices.min.tablet}px)`,
    desktopSm: `@media (min-width: ${devices.min.desktopSm}px)`,
    desktop: `@media (min-width: ${devices.min.desktop}px)`,
  },
  only: {
    mobile: `@media (max-width: ${devices.max.mobile}px)`,
    tablet: `@media (min-width: ${devices.min.tablet}px) and (max-width: ${devices.max.tablet}px)`,
    desktopSm: `@media (min-width: ${devices.min.desktopSm}px) and (max-width: ${devices.max.desktopSm}px)`,
    desktop: `@media (min-width: ${devices.min.desktop}px)`,
  },
} as const;

export const fluidBreakpoints = {
  min: 1024,
  max: 2562,
};

export const componentMaxWidths = {
  page: {
    full: '100%',
    main: '2419px',
    content: '2419px',
  },
  project: {
    full: '100%',
    main: '2420px',
    content: '2010px',
  },
};

export const horizontaFluidPaddings = {
  page: {
    full: '0',
    main: getProportionateVwPadding(
      fluidBreakpoints.max,
      stripUnit(componentMaxWidths.project.main)
    ),
    content: getProportionateVwPadding(
      fluidBreakpoints.max,
      stripUnit(componentMaxWidths.project.content)
    ),
  },
  project: {
    full: '0',
    main: getProportionateVwPadding(
      fluidBreakpoints.max,
      stripUnit(componentMaxWidths.project.main)
    ),
    content: getProportionateVwPadding(
      fluidBreakpoints.max,
      stripUnit(componentMaxWidths.project.content)
    ),
  },
};

export const isMobileScreen = (): boolean => {
  return window.matchMedia(medias.only.mobile).matches;
};

export const isTabletScreen = (): boolean => {
  return window.matchMedia(medias.only.tablet).matches;
};

export const isDesktopScreen = (): boolean => {
  return window.matchMedia(medias.only.desktop).matches;
};
